import { Box, Paper } from "@mui/material";
import { CustomText } from "components";
import { useNavigate } from "react-router-dom";
import { DEFAULT_ELEVATION } from "utility";

export const PaperButton = ({
  children = "",
  icon = "",
  onClick,
  to = "",
  className = "",
  background = "",
  color = "secondary",
  variant = "contained",
  elevation = DEFAULT_ELEVATION,
  iconPosition = "end",
}) => {
  const navigate = useNavigate();
  const isText = typeof children === "string";

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  const rendered = isText ? (
    <CustomText
      variant="body2"
      color={color}
      bold={600}
      className={`${className} transition-all duration-300 ${
        variant === "text"
          ? `border-b border-transparent hover:border-${color}`
          : ""
      }`}
    >
      {children}
    </CustomText>
  ) : (
    children
  );

  const ButtonContainer = variant === "text" ? Box : Paper;

  return (
    <ButtonContainer
      elevation={elevation}
      className={`${background} cursor-pointer flex justify-between items-center transition-all duration-300
        ${isText ? "px-4 py-2" : ""}
        ${variant === "outlined" ? "border border-bright-gray" : ""}
        ${variant === "text" ? "" : "hover:shadow-lg"}
      `}
      onClick={handleClick}
    >
      {iconPosition === "start" && icon && (
        <div className="mr-2 -mt-1">{icon}</div>
      )}
      {rendered}
      {iconPosition === "end" && icon && (
        <div className="ml-2 -mt-1">{icon}</div>
      )}
    </ButtonContainer>
  );
};
